// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1PKx6","amount":"Amount_amount__3_EWv","tip":"Amount_tip__3aEyf","tipHeader":"Amount_tipHeader__2p0Q0","tipsWrap":"Amount_tipsWrap__368Ni"};